import ApexTable from './apex-table.vue'

ApexTable.install = function(Vue) {
  Vue.component(ApexTable.name, ApexTable)
}

export default ApexTable
